export default "__VITE_ASSET__db0ce7ee__"